<template>
  <mtc-form-item :label="textLabel">
    <template v-if="item.view === 'date'">
      <template v-if="single_mode === item.mode">
        <j-date :placeholder="$t('tip.pleaseSelect')+textLabel" v-model="queryParam[item.field]" />
      </template>
      <template v-else>
        <j-date :placeholder="$t('label.startDate')" v-model="queryParam[item.field+'_begin']" style="width:calc(50% - 15px);" />
        <span class="group-query-strig">~</span>
        <j-date :placeholder="$t('label.endDate')" v-model="queryParam[item.field+'_end']" style="width:calc(50% - 15px);" />
      </template>
    </template>
    <template v-else-if="item.view === 'datetime'">
      <template v-if="single_mode===item.mode">
        <j-date :placeholder="$t('tip.pleaseSelect')+textLabel"
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                v-model="queryParam[item.field]" />
      </template>
      <template v-else>
        <j-date :placeholder="$t('label.pleaseChooseStartTime')"
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                v-model="queryParam[item.field+'_begin']"
                style="width:calc(50% - 15px);" />
        <span class="group-query-strig">~</span>
        <j-date :placeholder="$t('label.pleaseChooseEndTime')"
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                v-model="queryParam[item.field+'_end']"
                style="width:calc(50% - 15px);" />
      </template>
    </template>
    <template v-else-if="item.view === 'time'">
      <template v-if="single_mode===item.mode">
        <j-time :placeholder="$t('tip.pleaseSelect')+textLabel" date-format="HH:mm:ss" v-model="queryParam[item.field]" />
      </template>
      <template v-else>
        <j-time :placeholder="$t('label.pleaseChooseStartTime')"
                date-format="HH:mm:ss"
                v-model="queryParam[item.field+'_begin']"
                style="width:calc(50% - 15px);" />
        <span class="group-query-strig">~</span>
        <j-time :placeholder="$t('label.pleaseChooseEndTime')"
                date-format="HH:mm:ss"
                v-model="queryParam[item.field+'_end']"
                style="width:calc(50% - 15px);" />
      </template>
    </template>
    <template v-else-if="item.view === 'list' || item.view === 'radio' || item.view === 'switch'">
      <j-dict-select-tag v-if="item.config ==='1'"
                         :placeholder=" $t('tip.pleaseSelect')+textLabel "
                         v-model="queryParam[item.field]"
                         :dictCode="getDictCode(item)" />
      <a-select v-else
                :placeholder=" $t('tip.pleaseSelect')+textLabel "
                show-search
                :filter-option="filterOption"
                allowClear
                v-model="queryParam[item.field]">
        <a-select-option v-for="(op,opIndex) in dictOptions[item.field]"
                         :key="opIndex"
                         :value="op.value">
          {{ op.text }}
        </a-select-option>
      </a-select>
    </template>
    <template v-else-if="item.view === 'sel_tree'">
      <j-tree-select :placeholder="$t('tip.pleaseSelect')+textLabel"
                     v-model="queryParam[item.field]"
                     :dict="item.dict"
                     :pidField="item.pidField"
                     :pidValue="item.pidValue"
                     :hasChildField="item.hasChildField"
                     load-triggle-change />
    </template>
    <template v-else-if="item.view === 'cat_tree'">
      <j-category-select :pcode="item.pcode" v-model="queryParam[item.field]" :placeholder=" $t('tip.pleaseSelect')+textLabel " />
    </template>
    <template v-else-if=" item.view === 'sel_search' ">
      <j-search-select-tag v-if="item.config==='1'"
                           v-model="queryParam[item.field]"
                           :placeholder="`${$t('tip.pleaseChoose')}qq${textLabel}`"
                           :dict="getDictCode(item)" />
      <j-search-select-tag v-else
                           v-model="queryParam[item.field]"
                           :placeholder="$t('tip.pleaseSelect')+textLabel"
                           :dictOptions="dictOptions[item.field]" />
    </template>
    <template v-else-if=" item.view === 'sel_user' ">
      <j-select-user-by-dep v-model="queryParam[item.field]"
                            :placeholder="$t('tip.pleaseSelect')+textLabel"
                            trigger-change />
    </template>
    <template v-else-if=" item.view === 'sel_depart' ">
      <j-select-depart v-model="queryParam[item.field]"
                       :placeholder="$t('tip.pleaseSelect')+textLabel"
                       :trigger-change="true" />
    </template>
    <template v-else-if="item.view === 'popup'">
      <j-popup :placeholder=" $t('tip.pleaseSelect')+textLabel "
               v-model="queryParam[item.field]"
               :code="item.dictTable"
               :org-fields="item.dictCode"
               :dest-fields="item.dictText"
               :field="getPopupField(item.dictText)"
               :multi="true" />
    </template>
    <template v-else-if=" item.view === 'pca' ">
      <j-area-linkage :placeholder=" $t('tip.pleaseSelect')+textLabel " v-model="queryParam[item.field]" type="cascader" />
    </template>
    <template v-else-if=" item.view === 'checkbox' || item.view === 'list_multi'">
      <j-select-multiple v-if="item.config==='1'"
                         :placeholder=" $t('tip.pleaseSelect')+textLabel "
                         v-model="queryParam[item.field]"
                         :dictCode="getDictCode(item)" />
      <j-select-multiple v-else
                         :placeholder=" $t('tip.pleaseSelect')+textLabel "
                         :options="dictOptions[item.field]"
                         v-model="queryParam[item.field]" />
    </template>
    <template v-else>
      <template v-if="single_mode === item.mode">
        <j-input :placeholder=" $t('tip.pleaseInput')+textLabel " v-model="queryParam[item.field]" allowClear />
      </template>
      <template v-else>
        <j-input :placeholder="$t('tip.pleaseEnterStart')+textLabel"
                 v-model="queryParam[item.field+'_begin']"
                 allowClear
                 style="width:calc(50% - 15px);" />
        <span class="group-query-strig">~</span>
        <j-input :placeholder="$t('tip.pleaseEnterEnd')+textLabel"
                 v-model="queryParam[item.field+'_end']"
                 allowClear
                 style="width:calc(50% - 15px);" />
      </template>
    </template>
  </mtc-form-item>
</template>

<script>
export default {
  name: 'OnlineQueryFormItem',
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {
      },
      required: true
    },
    dictOptions: {
      type: Object,
      default: () => {
      },
      required: true
    },
    queryParam: {
      type: Object,
      default: () => {
      },
      required: true
    }
  },
  computed: {
    textLabel() {
      return this.$getLanguageEnable()? this.$t(`dynamic.${this.item.language_key}`): this.item.label
    }
  },
  data() {
    return {
      single_mode: 'single'
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getDictCode(item) {
      if (item.dictTable && item.dictTable.length > 0) {
        return item.dictTable + ',' + item.dictText + ',' + item.dictCode
      } else {
        return item.dictCode
      }
    },
    getPopupField(fields) {
      return fields.split(',')[ 0 ]
    }
  }
}
</script>

<style scoped>
.group-query-strig {
  width: 30px;
  text-align: center;
  display: inline-block;
}
</style>